import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBezierPointer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBezierPointer"><Path fillRule="evenodd" clipRule="evenodd" d="M11.658 11.658L22.23 14.6785L17.3215 17.3215L14.6785 22.23L11.658 11.658ZM13.842 13.842L15.1072 18.27L16.2142 16.2142L18.27 15.1072L13.842 13.842Z" fill="currentColor"/><Path d="M3 3V9H5.25V15H3V21H8.75V18.75H11V17.25H8.75V15H6.75V9H9V6.75H15V9H17.25V11H18.75V9H21V3H15V5.25H9V3H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBezierPointer;
